<template>
  <v-dialog
    fullscreen
    scrollable
    transition="dialog-bottom-transition"
    v-model="dialog_editAuftrag"
    width="1200"
  >
    <v-card>
      <v-card-title class="primary white--text" style="font-size:100%;">
        <v-container class="pa-0 d-flex justify-end">
          {{ editAuftrag.kundennummer }} - {{ editAuftrag.auftragsnummer }}
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog_delAuftrag"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                text dark
                :loading="prop_isSaving_delAuftrag"
                :disabled="prop_isSaving"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Auftrag löschen?
              </v-card-title>

              <v-card-text class="pt-4">
                Es werden sämtliche Daten und Dokumente gelöscht.
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  text
                  @click="dialog_delAuftrag = false;"
                >
                  Nichts tun
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  text
                  :disabled="prop_isSaving"
                  @click="
                    dialog_delAuftrag = false;
                    $emit('del', editAuftrag.id);
                  "
                >
                  löschen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            text dark
            @click="
              dialog_editAuftrag = false;
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-container>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-container class="pa-0">
          <v-tabs
            fixed-tabs
            v-if="$vuetify.breakpoint.smAndDown"
            v-model="tabs_auftragsdaten_mobile"
            show-arrows
            color="primary"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            class="mb-2"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab>Info</v-tab>
            <v-tab>Dokumente</v-tab>
          </v-tabs>
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-if="
                tabs_auftragsdaten_mobile === 0 ||
                $vuetify.breakpoint.mdAndUp
              "
            >
              <v-row align="center">
                <v-col>
                  <p class="text-h6 pa-2 primary--text mb-0">
                    Auftrag: {{ editAuftrag.auftragsnummer }}
                  </p>
                  letzte Statusänderung:
                  <span v-if="editAuftrag.time_lastUpdate > 0">
                    {{
                      new Date(editAuftrag.time_lastUpdate * 1000).toLocaleString('de-DE', {
                        year: 'numeric', month: '2-digit', day: '2-digit',
                        hour: 'numeric', minute: 'numeric',
                      })
                    }} Uhr
                  </span>
                  <span v-if="editAuftrag.time_lastUpdate <= 0">
                    --
                  </span>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="py-0">
                  <v-select
                    label="Auftragstyp"
                    :items="['Auftrag', 'Vertrag']"
                    v-model="editAuftrag.typ"
                  />
                </v-col>
                <v-col align="left" class="py-0">
                  <v-dialog
                    v-if="editAuftrag.leistungen.length > 0"
                    scrollable
                    v-model="dialog_ansicht1"
                    width="800"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        v-bind="attrs"
                        v-on="on"
                        text
                      >
                        <v-icon left>mdi-account-eye</v-icon>
                        Kostenübersicht
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title class="primary white--text">
                        <v-icon dark left>mdi-account-eye</v-icon>
                        Kostenübersicht
                      </v-card-title>

                      <v-card-text class="pt-4">
                        <div align="center">
                        <table>
                          <tr
                            v-for="(leistung, idx) in editAuftrag.leistungen"
                            :key="idx"
                            valign="top"
                          >
                            <td class="pa-1">{{ leistung.pos }}</td>
                            <td class="pa-1">
                              <b>{{ leistung.titel }}</b>
                              <p v-html="leistung.beschreibung.split('\n').join('<br>')"></p>
                            <!-- </td>
                            <td class="pa-1" width="90px" align="right"> -->
                              <div align="right">
                                <div
                                  v-if="leistung.anzahl > 1"
                                >
                                  {{ leistung.anzahl }}x
                                  {{ parseFloat(leistung.wert).toFixed(2).split('.').join(',') }} €
                                  <v-divider />
                                </div>
                                  {{ parseFloat(leistung.anzahl * leistung.wert)
                                  .toFixed(2).split('.').join(',') }} €
                                <div
                                  v-if="leistung.kosten > 0 && leistungenShowVerlustUndGewinn"
                                  class="red--text" style="font-size:60%;"
                                >
                                  - {{ parseFloat(leistung.kosten / (1 + (leistung.mwst / 100)))
                                  .toFixed(2).split('.').join(',') }} €
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><hr></td>
                            <td><hr></td>
                          </tr>
                          <tr>
                            <td class="pa-1" align="right"></td>
                            <td class="pa-1" align="right">
                              <b>Summe Netto:</b>
                              {{ parseFloat(leistungenSumme)
                                .toFixed(2).split('.').join(',') }} €
                            </td>
                          </tr>
                          <tr>
                            <td class="pa-1" align="right"></td>
                            <td class="pa-1" align="right">
                              <b>zzgl. {{ leistungenMwSt }}% MwSt.:</b>
                              {{ parseFloat(leistungenSummeMwSt)
                                .toFixed(2).split('.').join(',') }} €
                            </td>
                          </tr>
                          <tr>
                            <td class="pa-1" align="right"></td>
                            <td class="pa-1" align="right">
                              <b>Summe Brutto:</b>
                              {{ parseFloat(leistungenSummeBrutto)
                                .toFixed(2).split('.').join(',') }} €
                            </td>
                          </tr>
                          <tr class="green--text"
                            v-if="leistungenShowVerlustUndGewinn"
                          >
                            <td class="pa-1" align="right"></td>
                            <td class="pa-1" align="right">
                              <b>Summe Gewinn:</b>
                              {{ parseFloat(leistungenSummeGewinn)
                                .toFixed(2).split('.').join(',') }} €
                            </td>
                          </tr>
                        </table>
                        </div>
                        <v-divider />
                        <div v-html="auftragsbeschreibungNl2br">
                        </div>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-btn
                          text
                          @click="dialog_ansicht1 = false;"
                        >
                          Schließen
                        </v-btn>
                        <v-spacer />
                        <v-checkbox
                          v-model="leistungenShowVerlustUndGewinn"
                        />
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="dialog_ansicht1 = false;"
                        >
                          OK
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-autocomplete
                    :items="prop_kunden"
                    item-text="ident"
                    item-value="kundennummer"
                    label="Kunde"
                    v-model="editAuftrag.kundennummer"
                  />
                </v-col>
                <v-col class="py-0">
                  <v-select
                    v-if="editAuftrag.typ === 'Auftrag'"
                    :items="prop_settings.auftragsstatus"
                    item-text="kurz"
                    item-value="nummer"
                    label="Status"
                    v-model="editAuftrag.status"
                  />
                  <v-select
                    v-if="editAuftrag.typ === 'Vertrag'"
                    :items="prop_settings.vertragsstatus"
                    item-text="kurz"
                    item-value="nummer"
                    label="Status"
                    v-model="editAuftrag.status"
                  />
                </v-col>
              </v-row>
              <v-row v-if="editAuftrag.typ === 'Vertrag'">
                <v-col class="py-0">
                  <v-text-field
                    type="text"
                    label="Vertragsnummer"
                    v-model="editAuftrag.vertrag_nummer"
                    :rules="[
                      $store.state.main.inputValidationRules.name,
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="editAuftrag.typ === 'Vertrag'"
              >
                <v-col class="py-0">
                  <DatePicker
                    v-model="editAuftrag.vertrag_beginn"
                    label="Beginn"
                  />
                </v-col>
              </v-row>
              <v-row
                v-if="editAuftrag.typ === 'Vertrag'"
              >
                <v-col class="py-0 pb-4">
                  <DatePicker
                    v-model="editAuftrag.vertrag_ende"
                    label="Ende"
                  />
                  Ende Kündigungsfrist: {{ editAuftrag.vertrag_endeKuendigungsfrist }}
                </v-col>
                <v-col cols="2" class="py-0 pt-6">
                  <v-btn
                    x-small
                    @click="changedVertragBeginn();"
                  >
                    <v-icon small>mdi-auto-fix</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row
                v-if="editAuftrag.typ === 'Vertrag'"
              >
                <v-col class="py-0">
                  <v-select
                    :items="[
                      {value: 0, text: 'Monatlich'},
                      {value: 1, text: 'Jährlich'},
                      {value: 2, text: 'Quartalsweise'},
                      {value: 3, text: 'Halbjährlich'}
                    ]"
                    item-text="text"
                    item-value="value"
                    label="Zahlungsintervall"
                    v-model="editAuftrag.vertrag_zahlungJaehrlich"
                  />
                </v-col>
              </v-row>
              <v-text-field
                type="text"
                label="Titel"
                v-model="editAuftrag.titel"
                :rules="[
                  $store.state.main.inputValidationRules.name,
                ]"
              ></v-text-field>
              <v-textarea
                auto-grow
                label="Info"
                v-model="editAuftrag.beschreibung"
                hint="Öffentliche Info für den Kunden"
              ></v-textarea>
              <v-textarea
                auto-grow
                label="Admin Info"
                v-model="editAuftrag.adminInfo"
                hint="Private Info (Nicht für den Kunden sichtbar)"
              ></v-textarea>
              <v-row class="mt-4">
                <v-col>
                  <v-expansion-panels v-model="editAuftrag_extPan_leistungen">
                    <v-expansion-panel
                      v-for="(leistung, idx) in editAuftrag.leistungen"
                      :key="idx"
                    >
                      <v-expansion-panel-header disable-icon-rotate>
                        <template v-slot:actions>
                          <v-btn small text color="primary"
                            @click="delLeistung(idx)"
                          >
                            <v-icon>mdi-minus-box</v-icon>
                          </v-btn>
                        </template>
                        #{{ leistung.pos }}&nbsp;<b>{{ leistung.titel }}</b>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col class="py-0">
                            <v-select
                              label="Leistungstyp"
                              :items="prop_settings.leistungstypen"
                              v-model="leistung.id_leistungstyp"
                              item-text="nameMitMwSt"
                              item-value="id"
                              @change="leistungChangeLeistungstyp(leistung);"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0">
                            <v-select
                              label="Einnahmestelle"
                              :items="prop_settings.einnahmestellen"
                              v-model="leistung.id_einnahmestelle"
                              item-text="name"
                              item-value="id"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0" cols="3">
                            <v-text-field
                              type="number"
                              label="Pos."
                              v-model="leistung.pos"
                              :rules="[
                                $store.state.main.inputValidationRules.nummer,
                              ]"
                            ></v-text-field>
                          </v-col>
                          <v-col class="py-0">
                            <v-text-field
                              type="text"
                              label="Titel"
                              v-model="leistung.titel"
                              :rules="[]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0" cols="3">
                            <v-text-field
                              type="number"
                              label="Anzahl"
                              v-model="leistung.anzahl"
                              :rules="[
                                $store.state.main.inputValidationRules.nummer,
                              ]"
                            ></v-text-field>
                          </v-col>
                          <v-col class="py-0">
                            <v-text-field
                              type="number"
                              label="Nettowert in €"
                              v-model="leistung.wert"
                              :rules="[
                                $store.state.main.inputValidationRules.nummer,
                              ]"
                              @change="nettoInBrutto(leistung);"
                            ></v-text-field>
                          </v-col>
                          <v-col class="py-0">
                            <v-text-field
                              type="number"
                              label="Bruttowert in €"
                              v-model="leistung.wertBrutto"
                              :rules="[
                                $store.state.main.inputValidationRules.nummer,
                              ]"
                              @change="bruttoInNetto(leistung);"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row align="center">
                          <v-col class="py-0" cols="3" align="center">
                            <v-dialog
                              scrollable
                              v-model="leistung.dialog_selectKosten"
                              width="500"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  text
                                >
                                  <v-icon v-if="
                                    (
                                      leistung.id_kosten === '0'
                                      || !leistung.id_kosten
                                    )
                                    && (
                                      leistung.tabs_neuKosten === 0
                                      || !leistung.tabs_neuKosten
                                    )
                                  ">
                                    mdi-text-search
                                  </v-icon>
                                  <v-icon v-if="
                                    (
                                      leistung.id_kosten
                                      && leistung.id_kosten !== '0'
                                    )
                                    || leistung.tabs_neuKosten === 1
                                  "
                                  color="success">
                                    mdi-playlist-check
                                  </v-icon>
                                </v-btn>
                              </template>

                              <v-card>
                                <v-card-title class="text-h5 grey lighten-2">
                                  Kosten verknüpfen
                                </v-card-title>

                                <v-card-text class="pt-4">
                                  <v-tabs
                                    fixed-tabs
                                    v-model="leistung.tabs_neuKosten"
                                    @change="changeLeistungKosten(leistung);"
                                  >
                                    <v-tab>Wählen</v-tab>
                                    <v-tab>Neu</v-tab>
                                  </v-tabs>
                                  <v-autocomplete
                                    clearable
                                    v-if="leistung.tabs_neuKosten === 0"
                                    label="Kosten wählen"
                                    v-model="leistung.id_kosten"
                                    :items="prop_kosten.sort((a, b) => a.datum > b.datum ? -1 : 1)"
                                    item-text="titel2"
                                    item-value="id"
                                    no-data-text="Keine Suchergebnisse gefunden"
                                    @change="changeLeistungKosten(leistung);"
                                  />
                                  <template v-if="leistung.tabs_neuKosten === 1">
                                    <DatePicker
                                      v-model="leistung.neuKosten.datum"
                                    />
                                    <v-select
                                      :items="prop_settings.kostenstellen"
                                      item-text="name"
                                      item-value="id"
                                      label="Kostenstelle"
                                      v-model="leistung.neuKosten.id_kostenstelle"
                                    />
                                    <v-row>
                                      <v-col class="py-0">
                                        <v-text-field
                                          type="number"
                                          label="Wert [€]"
                                          v-model="leistung.neuKosten.betrag"
                                          :rules="[
                                            $store.state.main.inputValidationRules.nummer,
                                          ]"
                                          @change="changeLeistungKosten(leistung);"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col class="py-0">
                                        <v-text-field
                                          type="number"
                                          label="enthaltene MwSt [%]"
                                          v-model="leistung.neuKosten.mwst"
                                          :rules="[
                                            $store.state.main.inputValidationRules.nummer,
                                          ]"
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-text-field
                                      type="text"
                                      label="Titel"
                                      v-model="leistung.neuKosten.titel"
                                      :rules="[
                                        $store.state.main.inputValidationRules.name,
                                      ]"
                                    ></v-text-field>
                                    <v-textarea
                                      auto-grow
                                      label="Beschreibung"
                                      v-model="leistung.neuKosten.beschreibung"
                                      hint=""
                                    ></v-textarea>
                                  </template>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                  <v-btn
                                    text
                                    @click="leistung.dialog_selectKosten = false;"
                                  >
                                    Schließen
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text color="primary"
                                    @click="leistung.dialog_selectKosten = false;"
                                  >
                                    OK
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>
                          <v-col class="py-0">
                            <v-text-field
                              type="number"
                              label="Kosten in € (Brutto)"
                              v-model="leistung.kosten"
                              :rules="[
                                $store.state.main.inputValidationRules.nummer,
                              ]"
                              v-if="
                                !(
                                  leistung.id_kosten
                                  && leistung.id_kosten !== '0'
                                )
                              "
                              :disabled="
                                (
                                  leistung.id_kosten
                                  && leistung.id_kosten !== '0'
                                )
                                || leistung.tabs_neuKosten === 1
                              "
                            ></v-text-field>
                            <v-text-field
                              v-else-if="
                                prop_kosten.filter((o) => o.id === leistung.id_kosten).length > 0
                              "
                              label="Verknüpfte Kosten"
                              :value="
                                verknuepfteKostenName(
                                  prop_kosten.filter((o) => o.id === leistung.id_kosten)[0],
                                )
                              "
                              :rules="[
                                $store.state.main.inputValidationRules.nummer,
                              ]"
                              :disabled="true"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0">
                            <v-textarea
                              auto-grow
                              label="Leistungsbeschreibung"
                              v-model="leistung.beschreibung"
                              hint=""
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <div align="center">
                    <v-btn small text color="primary" class="ma-2"
                      @click="addLeistung();"
                    >
                      <v-icon left>mdi-plus-box</v-icon>
                      Leistung
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                tabs_auftragsdaten_mobile === 1 ||
                $vuetify.breakpoint.mdAndUp
              "
            >
              <p class="text-h6 pa-2 primary--text mb-0">
                Dokumente
              </p>
              <v-dialog
                scrollable
                v-model="dialog_neuDokument"
                width="500"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    text
                  >
                    <v-icon left>mdi-plus-box</v-icon>
                    Dokument anhängen
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title class="primary white--text">
                    <v-icon left dark>mdi-paperclip</v-icon>
                    Dokument anhängen
                  </v-card-title>

                  <v-card-text class="pt-4">
                    <v-select
                      label="Art des Anhangs"
                      :items="prop_settings.auftraegeDokumentarten.filter((
                        (o) => {
                          if (
                            o.fuerKosten !== 1
                            || o.nummer === 1
                            || o.nummer === 100
                          ) {
                            return o;
                          }
                          return null;
                        }
                      ))"
                      v-model="neuDokument.dokumentart"
                      item-text="kurz"
                      item-value="nummer"
                      @change="neuDokumentKorrekturPruefen();"
                    />
                    <v-alert
                      v-if="neuDokumentFehler"
                      class="mb-4"
                      dense
                      outlined
                      type="error"
                    >
                      {{ neuDokumentFehler }}
                    </v-alert>
                    <template
                      v-if="
                        neuDokument.dokumentart === 1
                        || neuDokument.dokumentart === 2
                      "
                    >
                      <DatePicker
                        v-model="neuDokument.datum"
                        @change="neuDokumentGetMoeglicheUhrzeiten();"
                      />
                      <v-row
                        v-if="
                          neuDokument.showTerminPlanen
                          && neuDokument.terminPlanenMoeglicheUhrzeiten.length > 0
                          && prop_settings.rechnungen_planenCronjobsMoeglich
                        "
                      >
                        <v-col class="py-0">
                          <v-checkbox
                            :label="`${neuDokument.dokumentartName}serstellung planen`"
                            v-model="neuDokument.terminPlanen"
                            @change="neuDokumentKorrekturPruefen();"
                          />
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="neuDokument.terminPlanen"
                      >
                        <v-col class="py-0"
                          v-if="editAuftrag.typ === 'Vertrag'"
                        >
                          <v-select
                            :label="`Wiederholen`"
                            :items="[
                              { value: '0', text: `Einmalig (${neuDokumentDatumDE})` },
                              { value: '1', text: 'Zahlungsintervall (Regelmäßig)' },
                            ]"
                            v-model="neuDokument.terminPlanenWiederholen"
                            @change="neuDokumentGetMoeglicheUhrzeiten();"
                          />
                          <p
                            v-if="
                              editAuftrag.vertrag_zahlungJaehrlich === 0
                              && neuDokument.terminPlanenWiederholen === '1'
                            "
                          >
                            {{ neuDokument.dokumentartName }} wird monatlich ab
                            Vertragsbeginn erstellt.
                          </p>
                          <p
                            v-if="
                              editAuftrag.vertrag_zahlungJaehrlich === 1
                              && neuDokument.terminPlanenWiederholen === '1'
                            "
                          >
                            {{ neuDokument.dokumentartName }}
                            wird zum Vertragsbeginn sowie jährlich zur
                            Vertragsverlängerung erstellt.
                          </p>
                          <p
                            v-if="
                              editAuftrag.vertrag_zahlungJaehrlich === 2
                              && neuDokument.terminPlanenWiederholen === '1'
                            "
                          >
                            {{ neuDokument.dokumentartName }}
                            wird quartalsweise ab
                            Vertragsbeginn erstellt.
                          </p>
                          <p
                            v-if="
                              editAuftrag.vertrag_zahlungJaehrlich === 3
                              && neuDokument.terminPlanenWiederholen === '1'
                            "
                          >
                            {{ neuDokument.dokumentartName }}
                            wird halbjährlich ab
                            Vertragsbeginn erstellt.
                          </p>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="neuDokument.terminPlanen"
                      >
                        <v-col class="py-0">
                          <v-autocomplete
                            label="Uhrzeit"
                            :items="neuDokument.terminPlanenMoeglicheUhrzeiten"
                            v-model="neuDokument.terminPlanenUhrzeit"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-0">
                          <v-checkbox
                            v-model="neuDokument.automatischeReAnNummer"
                            :label="`Automatische ${neuDokument.dokumentartName}snummer`"
                            @change="neuDokumentKorrekturPruefen();"
                          />
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="!neuDokument.automatischeReAnNummer"
                      >
                        <v-col
                          class="py-0"
                        >
                          <p v-if="neuDokument.dokumentart === 1">
                            Bereits vergebene Rechnungsnummern sind geschützt.
                            Für eine bereits in diesem Auftrag erstellte Rechnung oder
                            eine dort erneut hochgeladene Altrechnung können Sie nach
                            Eingabe ihrer Nummer unten ausdrücklich eine
                            Rechnungskorrektur aktivieren.
                          </p>
                          <p v-else>
                            Bereits vergebene Angebotsnummern sind geschützt und
                            können nicht erneut vergeben werden.
                          </p>
                          <v-text-field
                            type="number"
                            :label="`${neuDokument.dokumentartName}snummer`"
                            v-model="neuDokument.reAnNummer"
                            :rules="[
                              $store.state.main.inputValidationRules.nummer,
                            ]"
                          ></v-text-field>
                          <v-checkbox
                            v-if="
                              neuDokument.dokumentart === 1
                              && !neuDokument.terminPlanen
                            "
                            v-model="neuDokument.rechnungskorrekturBestaetigt"
                            @change="neuDokumentKorrekturBestaetigungGeaendert"
                            class="mt-0"
                            hide-details
                            label="Rechnungskorrektur erstellen"
                          />
                          <v-alert
                            v-if="neuDokument.rechnungskorrekturBestaetigt"
                            class="mt-3 mb-4"
                            dense
                            outlined
                            type="warning"
                          >
                            Die bisherige Fassung wird im geschützten Archiv aufbewahrt;
                            die korrigierte Rechnung behält dieselbe Rechnungsnummer.
                            Dies ist nur möglich, wenn im aktuellen Auftrag genau eine
                            passende Rechnung vorhanden ist. Eine gelöschte Altrechnung
                            laden Sie dafür zunächst als RE-&lt;Nummer&gt;.pdf hoch.
                          </v-alert>
                        </v-col>
                      </v-row>
                      <v-checkbox
                        label="Individuelle Anschrift"
                        v-model="neuDokument.useIndividuelleAnschrift"
                      />
                      <v-select
                        no-data-text="Keine Anschriften vorhanden"
                        v-if="!neuDokument.useIndividuelleAnschrift"
                        label="Anschrift"
                        :items="neuDokument.moeglicheAnschriften"
                        v-model="neuDokument.anschriftId"
                        item-text="bezeichnung"
                        item-value="id"
                        @change="neuDokumentChangeAnschrift();"
                      />
                      <v-select
                        no-data-text="Keine Ansprechpartner vorhanden"
                        v-if="!neuDokument.useIndividuelleAnschrift"
                        label="Ansprechpartner"
                        :items="neuDokument.moeglicheAnsprechpartner"
                        v-model="neuDokument.ansprechpartnerId"
                        item-text="ident"
                        item-value="id"
                        @change="neuDokumentChangeAnsprechpartner();"
                      />
                      <v-textarea
                        v-if="neuDokument.useIndividuelleAnschrift"
                        auto-grow
                        label="Anschrift"
                        v-model="neuDokument.individuelleAnschrift"
                        hint=""
                        max-height="5"
                      ></v-textarea>
                      <v-select
                        multiple
                        label="Textblöcke"
                        :items="prop_settings.rechnungenTextbloecke"
                        item-text="kurz"
                        item-value="id"
                        v-model="neuDokument.textbloecke"
                        no-data-text="Keine Textblöcke vorhanden"
                      />
                      <v-textarea
                        v-if="neuDokument.textbloecke.includes(1)"
                        auto-grow
                        label="individueller Textblock"
                        v-model="neuDokument.individuellerTextblock"
                        hint=""
                      ></v-textarea>
                      <v-text-field
                        type="number"
                        label="Anzahlung in €"
                        v-model="neuDokument.anzahlung"
                        :rules="[
                          $store.state.main.inputValidationRules.nummer,
                        ]"
                      ></v-text-field>
                      <v-row
                        v-if="
                          neuDokument.dokumentart === 2
                        "
                      >
                        <v-col class="py-0">
                          <v-select
                            :label="`Unterschrift`"
                            :items="prop_settings.unterschriften"
                            item-value="nummer"
                            item-text="name"
                            v-model="neuDokument.angebotUnterschriftAuftragnehmer"
                          />
                        </v-col>
                      </v-row>
                      <v-checkbox
                        v-if="neuDokument.ansprechpartner.mail !== ''"
                        :label="`${neuDokument.dokumentartName} per E-Mail senden`"
                        v-model="neuDokument.terminPlanenSenden"
                      />
                      <div v-if="neuDokument.terminPlanenSenden">
                        An: {{ neuDokument.ansprechpartner.mail }}
                      </div>
                      <v-text-field
                        v-if="neuDokument.terminPlanenSenden && 1 === 2"
                        type="text"
                        label="Betreff"
                        v-model="neuDokument.terminPlanenSendenBetreff"
                        :rules="[
                          $store.state.main.inputValidationRules.name,
                        ]"
                      ></v-text-field>
                      <v-textarea
                        v-if="neuDokument.terminPlanenSenden"
                        auto-grow
                        label="E-Mail Text (optional)"
                        v-model="neuDokument.terminPlanenSendenText"
                        hint="Wird an den automatisch generierten Text angehängt."
                      ></v-textarea>
                    </template>
                    <template
                      v-if="
                        neuDokument.dokumentart === 100
                      "
                    >
                      <!-- Dokument hochladen -->
                      <UploadBilderPDF
                        :apipath="
                          `400/410/neuDokument/?key=${this.$store.state.login.session.code}&fill=
                          &id_a=${neuDokument.id_auftrag}`
                        "
                        accept="application/pdf, image/*"
                        @neuDokumente="addDokumente($event);"
                        @gespeichert="dokumentSpeicherungBestaetigt($event)"
                      />
                    </template>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn
                      text small
                      @click="dialog_neuDokument = false;"
                    >
                      Schließen
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="
                        neuDokument.dokumentart !== 100
                      "
                      color="primary"
                      text
                      @click="trySaveNeuDokument();"
                      :loading="loading_saveDokument"
                    >
                      {{ neuDokument.rechnungskorrekturBestaetigt
                        ? 'Rechnungskorrektur erstellen' : 'Speichern' }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <Zahlungsdeckung :settlement="editAuftrag.settlement" />
              <v-alert v-if="editAuftrag.typ === 'Vertrag'" type="info" dense text>
                Rechnungen erhöhen den offenen Betrag, Buchungsbelege und bestätigte Zahlungen verringern ihn.
                Eine Zahlung beendet den laufenden Vertrag nicht.
              </v-alert>
              <v-data-table
                :headers="headers"
                :items="sortierteDokumente"
                :search="search"
                :loading="loading"
                :items-per-page="10"
                :page.sync="dokumentePage"
                :header-props="headerProps"
                :footer-props="footerProps"
                disable-sort
                no-data-text="Keine Dokumente gefunden"
                no-results-text="Keine Dokumente gefunden"
                loading-text="Lade Daten... Bitte warten"
                mobile-breakpoint="600"
              >
                <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                  {{ pageStart }} - {{ pageStop }} von {{ itemsLength }}
                </template>
                <template v-slot:item.dokumentart="{ item }">
                  <div class="d-flex align-center text-caption">
                    <v-icon small
                      left color="red"
                      v-if="
                        item.dokumentart === 1
                        || item.dokumentart === 2
                      "
                    >mdi-file-pdf-box</v-icon>
                    <span
                      v-if="item.dokumentart === 1"
                    >Rechnung</span>
                    <span
                      v-if="item.dokumentart === 2"
                    >Angebot</span>
                    <v-icon small
                      left color="success"
                      v-if="
                        item.dokumentart === 20
                      "
                    >mdi-receipt-text-check-outline</v-icon>
                    <span
                      v-if="item.dokumentart === 20"
                    >Buchungsbeleg</span>
                    <v-icon small
                      left
                      v-if="
                        item.dokumentart === 100
                      "
                    >mdi-upload</v-icon>
                    <span
                      v-if="item.dokumentart === 100"
                    >Hochgeladen</span>
                </div>
                <div class="ps-2">
                  {{ item.name }}
                </div>
                <template v-if="item.dokumentart === 1 && !item.geplanteRechnung">
                  <NachweisStatus :evidence="item.evidence" :zeige-bank="false" />
                  <Zahlungsdeckung :settlement="rechnungZahlungsdeckung(item)" />
                  <v-dialog v-model="dialog_nachweis[item.id]" max-width="720" scrollable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small text color="primary" v-bind="attrs" v-on="on">
                        Zahlung bestätigen
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>{{ item.name }} · Zahlungen</v-card-title>
                      <v-card-text>
                        <ManuelleZahlungen
                          v-if="dialog_nachweis[item.id]" target-type="order_document"
                          :target-id="item.id" :refresh-key="nachweisAktualisierung"
                          @changed="nachweisGeaendert(item.id, $event)"
                        />
                        <v-expansion-panels flat>
                          <v-expansion-panel>
                            <v-expansion-panel-header>Belegangaben und optionale Prüfung</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <NachweisPruefung
                                v-if="dialog_nachweis[item.id]" target-type="order_document"
                                :target-id="item.id" :evidence="item.evidence"
                                :refresh-key="nachweisAktualisierung"
                                @changed="nachweisGeaendert(item.id, $event)"
                              />
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card-text>
                      <v-card-actions><v-spacer /><v-btn text @click="dialog_nachweis[item.id] = false">Schließen</v-btn></v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
                </template>
                <template v-slot:item.upload="{ item }">
                  {{item.dateUpload }} {{item.timeUpload }}
                </template>
                <template v-slot:item.aktion="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>mdi-menu</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-dialog
                        v-if="item.geplanteRechnung"
                        v-model="dialog_geplantesDokument[item.id]"
                        max-width="700"
                        scrollable
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-list-item-title>
                              <v-icon left>mdi-calendar-search</v-icon>
                              Planung ansehen
                            </v-list-item-title>
                          </v-list-item>
                        </template>

                        <v-card>
                          <v-card-title class="primary white--text">
                            <v-icon left dark>mdi-calendar-clock</v-icon>
                            Geplantes Dokument
                          </v-card-title>
                          <v-card-text class="pt-4">
                            <v-alert
                              dense
                              text
                              type="info"
                            >
                              Leistungspositionen sowie eine verknüpfte Anschrift und
                              Ansprechperson werden bei der Ausführung neu geladen.
                            </v-alert>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr>
                                    <th class="text-left">Nächste Ausführung</th>
                                    <td>{{ item.dateUpload }} {{ item.timeUpload }} Uhr</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">Wiederholung</th>
                                    <td>{{ geplantesDokumentWiederholung(item) }}</td>
                                  </tr>
                                  <tr v-if="item.planenWiederholen">
                                    <th class="text-left">Nächster Folgetermin</th>
                                    <td>{{ formatierePlanungszeitpunkt(item.planenWiederholen) }}</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">Dokumentart</th>
                                    <td>{{ geplantesDokumentArt(item) }}</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">Dokumentnummer</th>
                                    <td>{{ geplantesDokumentNummer(item) }}</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">Leistungspositionen</th>
                                    <td>Aktueller Stand des Auftrags am Ausführungstag</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">Textblöcke</th>
                                    <td>{{ geplantesDokumentTextbloecke(item) }}</td>
                                  </tr>
                                  <tr
                                    v-if="
                                      item.neuDokument
                                      && item.neuDokument.individuellerTextblock
                                    "
                                  >
                                    <th class="text-left">Individueller Textblock</th>
                                    <td style="white-space:pre-line;">{{
                                      item.neuDokument.individuellerTextblock
                                    }}</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">Anzahlung</th>
                                    <td>{{ geplantesDokumentAnzahlung(item) }}</td>
                                  </tr>
                                  <tr v-if="item.dokumentart === 2">
                                    <th class="text-left">Unterschrift</th>
                                    <td>{{ geplantesDokumentUnterschrift(item) }}</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">Anschrift</th>
                                    <td style="white-space:pre-line;">{{
                                      geplantesDokumentAnschrift(item)
                                    }}</td>
                                  </tr>
                                  <tr>
                                    <th class="text-left">E-Mail-Versand</th>
                                    <td>{{ geplantesDokumentEmailVersand(item) }}</td>
                                  </tr>
                                  <tr
                                    v-if="
                                      item.neuDokument
                                      && item.neuDokument.terminPlanenSenden
                                    "
                                  >
                                    <th class="text-left">Empfänger</th>
                                    <td>
                                      {{ geplantesDokumentEmpfaenger(item) }}<br>
                                      {{ geplantesDokumentEmail(item) }}
                                    </td>
                                  </tr>
                                  <tr
                                    v-if="
                                      item.neuDokument
                                      && item.neuDokument.terminPlanenSenden
                                      && item.neuDokument.terminPlanenSendenText
                                    "
                                  >
                                    <th class="text-left">Zusätzlicher E-Mail-Text</th>
                                    <td style="white-space:pre-line;">{{
                                      item.neuDokument.terminPlanenSendenText
                                    }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="dialog_geplantesDokument[item.id] = false"
                            >
                              Schließen
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog
                        v-if="!item.geplanteRechnung"
                        v-model="dialog_editDokument[item.id]"
                        width="500"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <!-- <v-btn text
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn> -->
                          <v-list-item
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-list-item-title>
                              <v-icon left>mdi-pencil</v-icon>
                              Bearbeiten
                            </v-list-item-title>
                          </v-list-item>
                        </template>

                        <v-card>
                          <v-card-title class="text-h5 grey lighten-2">
                            Dokument bearbeiten
                          </v-card-title>

                          <v-card-text class="pt-4">
                            <v-select
                              label="Art des Dokuments"
                              :items="prop_settings.auftraegeDokumentarten"
                              v-model="item.dokumentart"
                              item-text="name"
                              item-value="nummer"
                            />
                            <DatePicker
                              v-model="item.dateUpload2"
                              @change="changeDokumentDatum(item);"
                            />
                            <v-text-field
                              type="text"
                              label="Titel"
                              v-model="item.name"
                              :rules="[
                                $store.state.main.inputValidationRules.name,
                              ]"
                            ></v-text-field>
                            <v-text-field
                              type="number"
                              label="Wert"
                              v-model="item.wert"
                              :rules="[
                                $store.state.main.inputValidationRules.nummer,
                              ]"
                            ></v-text-field>
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-btn
                              text
                              @click="dialog_editDokument[item.id] = false;"
                            >
                              Schließen
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                              text color="primary"
                              @click="dialog_editDokument[item.id] = false;"
                            >
                              OK
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-list-item
                        v-if="!item.geplanteRechnung && item.hasContent !== false"
                        @click="tryDownloadDokument(item.pfad, item.name, true);"
                      >
                        <v-list-item-title>
                          <v-icon left>mdi-eye-outline</v-icon>
                          Ansehen
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="!item.geplanteRechnung && item.hasContent !== false"
                        @click="tryDownloadDokument(item.pfad, item.name, false);"
                      >
                        <v-list-item-title>
                          <v-icon left>mdi-download</v-icon>
                          Download
                        </v-list-item-title>
                      </v-list-item>
                      <v-dialog
                        v-model="dialog_delDokument[item.id]"
                        width="500"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <!-- <v-btn text color="error"
                            v-bind="attrs"
                            v-on="on"
                            :loading="item.loadingDelete"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn> -->
                          <v-list-item
                            v-bind="attrs"
                            v-on="on"
                            :loading="item.loadingDelete"
                          >
                            <v-list-item-title>
                              <v-icon left>mdi-delete</v-icon>
                              Löschen
                            </v-list-item-title>
                          </v-list-item>
                        </template>

                        <v-card>
                          <v-card-title class="text-h5 grey lighten-2">
                            Dokument löschen?
                          </v-card-title>

                          <v-card-text class="pt-4">
                            Das Dokument wird unwiderruflich gelöscht.
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-btn
                              text
                              @click="dialog_delDokument[item.id] = false;"
                            >
                              Nichts tun
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="error"
                              text
                              @click="
                                dialog_delDokument[item.id] = false;
                                tryDelDokument(item.id, item.pfad);
                              "
                            >
                              löschen
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-list>
                  </v-menu>
                  <!-- <v-btn text color="primary"
                    v-if="!item.geplanteRechnung"
                    @click="tryDownloadDokument(item.pfad, item.name, true);"
                    :loading="item.loadingDownload"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn> -->
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container
          class="pa-0 d-flex justify-end"
        >
          <v-btn
            text small
            @click="
              dialog_editAuftrag = false;
            "
          >
            schließen
          </v-btn>
          <v-btn
            color="primary"
            text small
            @click="
              $emit('save', editAuftrag);
            "
            :disabled="prop_isSaving || xLoaded === JSON.stringify(editAuftrag)"
            :loading="prop_isSaving_editAuftrag"
          >
            Speichern
          </v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import $ from 'jquery';
import UploadBilderPDF from '@/components/Inputs/UploadBilderPDF.vue';
import DatePicker from '@/components/Inputs/DatePicker.vue';
import { apiFehlermeldung, sichereApiFehlermeldung } from '@/utils/apiFehler';
import NachweisPruefung from './NachweisPruefung.vue';
import ManuelleZahlungen from './ManuelleZahlungen.vue';
import NachweisStatus from './NachweisStatus.vue';
import Zahlungsdeckung from './Zahlungsdeckung.vue';
import { cacheNachweisAktualisieren } from '@/utils/nachweisStatus';

export default {
  components: {
    ManuelleZahlungen,
    NachweisPruefung,
    NachweisStatus,
    Zahlungsdeckung,
    UploadBilderPDF,
    DatePicker,
  },
  props: {
    prop_saveErgebnis: {
      type: Object,
      default: null,
    },
    prop_auftrag: {
      type: Object,
      default() { return {}; },
    },
    prop_isSaving: {
      type: Boolean,
      default: false,
    },
    prop_isSaving_editAuftrag: {
      type: Boolean,
      default: false,
    },
    prop_isSaving_delAuftrag: {
      type: Boolean,
      default: false,
    },
    prop_kunden: {
      type: Array,
      default() { return []; },
    },
    prop_kosten: {
      type: Array,
      default() { return []; },
    },
    prop_settings: {
      type: Object,
      default() { return {}; },
    },
  },
  data: () => ({
    dialog_nachweis: {},
    nachweisAktualisierung: 0,
    leistungenShowVerlustUndGewinn: false,
    loading_saveDokument: false,
    loading_delDokument: {},
    dialog_editDokument: {},
    dialog_geplantesDokument: {},
    dialog_ansicht1: false,
    dialog_delDokument: {},
    dialog_neuDokument: false,
    tabs_auftragsdaten_mobile: null,
    dialog_editAuftrag: false,
    dialog_delAuftrag: false,
    editAuftrag_extPan_leistungen: null,
    editAuftrag: {},
    neuKosten: {},
    tabs_neuKosten: null,
    xLoaded: '',
    neuDokument: {},
    neuDokumentIdAnschrift: '',
    neuDokumentFehler: '',
    neuDokumentFehlerCode: '',
    loading: false,
    search: '',
    dokumentePage: 1,
    headers: [
      // { text: 'Auftrag', value: 'auftragsnummer', width: '150px' },
      {
        text: '', value: 'aktion', sortable: false, width: '80px',
      },
      { text: 'Art', value: 'dokumentart' },
      // { text: 'Name', value: 'name' },
      { text: 'Upload', value: 'upload' },
    ],
    headerProps: {
      sortByText: 'Sortiere nach',
    },
    footerProps: {
      itemsPerPageText: 'Elemente pro Seite:',
      itemsPerPageOptions: [5, 10, 20, 50, -1],
      itemsPerPageAllText: 'Alle',
    },
  }),
  computed: {
    sortierteDokumente() {
      if (!Array.isArray(this.editAuftrag.dokumente)) {
        return [];
      }
      return [...this.editAuftrag.dokumente].sort((a, b) => {
        const zeitDifferenz = this.dokumentTimestamp(b) - this.dokumentTimestamp(a);
        if (zeitDifferenz !== 0) {
          return zeitDifferenz;
        }
        return Number(b.id) - Number(a.id);
      });
    },
    leistungenSumme() {
      let summe = 0;
      this.editAuftrag.leistungen.forEach((l) => {
        summe += parseFloat(l.wert) * parseFloat(l.anzahl);
      });
      return summe;
    },
    leistungenSummeGewinn() {
      let summe = 0;
      this.editAuftrag.leistungen.forEach((l) => {
        const { kosten } = l;
        summe += parseFloat(l.wert);
        summe *= parseFloat(l.anzahl);
        summe -= parseFloat((kosten / (1 + (l.mwst / 100))));
      });
      return summe;
    },
    leistungenSummeMwSt() {
      let summe = 0;
      this.editAuftrag.leistungen.forEach((l) => {
        summe += parseFloat(l.wert) * parseFloat(l.anzahl) * (0 + parseFloat(l.mwst) / 100);
      });
      return summe;
    },
    leistungenMwSt() {
      let mwst = 0;
      this.editAuftrag.leistungen.forEach((l) => {
        if (l.mwst > mwst) {
          mwst = parseFloat(l.mwst);
        }
      });
      return mwst;
    },
    leistungenSummeBrutto() {
      let summe = 0;
      this.editAuftrag.leistungen.forEach((l) => {
        summe += parseFloat(l.wert) * parseFloat(l.anzahl) * (1 + parseFloat(l.mwst) / 100);
      });
      return summe;
    },
    neuDokumentDatumDE() {
      const datum = this.neuDokument.datum.split('-');
      return `${datum[2]}.${datum[1]}.${datum[0]}`;
    },
    neuDokumentDatumVertragsbeginnDE() {
      const datum = this.editAuftrag.vertrag_beginn.split('-');
      return `${datum[2]}.${datum[1]}.${datum[0]}`;
    },
    auftragsbeschreibungNl2br() {
      return this.editAuftrag.beschreibung.split('\n').join('<br>');
    },
  },
  watch: {
    prop_saveErgebnis(ergebnis) {
      this.auftragsSpeicherungBestaetigt(ergebnis);
    },
    prop_auftrag: {
      handler(neu) {
        this.editAuftrag.leistungen.forEach((l) => {
          if (neu.leistungen.filter((o) => o.pos === l.pos).length > 0) {
            const i = neu.leistungen.filter((o) => o.pos === l.pos)[0];
            l.id_kosten = i.id_kosten;
            l.tabs_neuKosten = i.tabs_neuKosten;
            l.betrag = i.betrag;
          }
        });
        // this.editAuftrag.leistungen = neu.leistungen;
      },
      deep: true,
    },
    editAuftrag: {
      handler() {
        this.changedVertragEnde();
      },
      deep: true,
    },
    dialog_editAuftrag(neu) {
      if (neu === false) {
        setTimeout(() => {
          this.$emit('close');
        }, 400);
      }
    },
    neuDokument: {
      handler() {
        this.updateNeuDokument();
      },
      deep: true,
    },
    dialog_neuDokument(neu) {
      if (neu === true) {
        this.neuDokumentFehler = '';
        this.neuDokumentFehlerCode = '';
        this.resetNeuDokument();
      }
    },
  },
  methods: {
    auftragsSpeicherungBestaetigt(ergebnis) {
      if (!ergebnis || !ergebnis.auftrag || !ergebnis.gesendet
        || String(ergebnis.auftrag.id) !== String(this.editAuftrag.id)) return;
      const stand = JSON.parse(JSON.stringify({ ...ergebnis.gesendet, ...ergebnis.auftrag }));
      const neuererZahlungsstand = this.editAuftrag.settlement && stand.settlement
        && Number(this.editAuftrag.settlement.rowVersion) > Number(stand.settlement.rowVersion);
      if (neuererZahlungsstand) {
        stand.settlement = JSON.parse(JSON.stringify(this.editAuftrag.settlement));
        stand.status = JSON.parse(this.xLoaded).status;
      }
      Object.keys(stand).forEach((feld) => {
        // Nur eigene bestaetigte Antworten uebernehmen. Ein allgemeines Reload
        // darf die Versionspruefung eines veralteten Dialogs nicht aushebeln.
        if (neuererZahlungsstand && feld === 'status') return;
        if (feld === 'settlement' || feld === 'time_lastUpdate'
          || JSON.stringify(this.editAuftrag[feld]) === JSON.stringify(ergebnis.gesendet[feld])) {
          this.$set(this.editAuftrag, feld, JSON.parse(JSON.stringify(stand[feld])));
        }
      });
      this.xLoaded = JSON.stringify(stand);
      if (stand.settlement) {
        this.$set(this.prop_auftrag, 'settlement', stand.settlement);
        this.$set(this.prop_auftrag, 'status', stand.status);
        cacheNachweisAktualisieren({ settlement: stand.settlement });
      }
    },
    dokumentSpeicherungBestaetigt(response) {
      if (response && response.settlement) this.nachweisGeaendert(null, response);
    },
    rechnungZahlungsdeckung(item) {
      const stand = this.editAuftrag.settlement;
      return (stand && stand.invoices || []).find((r) => String(r.documentId) === String(item.id))
        || item.settlement || null;
    },
    nachweisGeaendert(id, response) {
      const settlement = response.settlement;
      const zahlungsstandAktuell = settlement
        && String(settlement.orderId) === String(this.editAuftrag.id)
        && (!this.editAuftrag.settlement
          || Number(settlement.rowVersion) >= Number(this.editAuftrag.settlement.rowVersion));
      const statusUnveraendert = String(this.editAuftrag.status) === String(this.prop_auftrag.status);
      const geladen = JSON.parse(this.xLoaded);
      [this.editAuftrag, this.prop_auftrag, geladen].forEach((auftrag) => {
        const dokument = auftrag.dokumente.find((d) => String(d.id) === String(id));
        if (dokument && response.evidence) this.$set(dokument, 'evidence', response.evidence);
        ((response.evidence && response.evidence.availableDocuments) || []).forEach((datei) => {
          const d = auftrag.dokumente.find((o) => String(o.id) === String(datei.id));
          if (d) this.$set(d, 'hasContent', datei.hasContent);
        });
        if (zahlungsstandAktuell) {
          this.$set(auftrag, 'settlement', response.settlement);
          this.$set(auftrag, 'offeneRechnungen', { betrag: Number(response.settlement.openAmountMinor) / 100 });
          if (response.settlement.currentStatus !== undefined
            && (auftrag !== this.editAuftrag || statusUnveraendert)) {
            this.$set(auftrag, 'status', response.settlement.currentStatus);
          }
          (response.settlement.invoices || []).forEach((rechnung) => {
            const r = auftrag.dokumente.find((d) => String(d.id) === String(rechnung.documentId));
            if (r) this.$set(r, 'settlement', rechnung);
          });
        }
      });
      this.xLoaded = JSON.stringify(geladen);
      cacheNachweisAktualisieren(zahlungsstandAktuell ? response : { ...response, settlement: null });
    },
    async aktualisiereNachweise() {
      // Nur Serverfelder aktualisieren; ungespeicherte Auftragsdaten bleiben im Dialog erhalten.
      const rechnungen = this.editAuftrag.dokumente.filter((d) => d.dokumentart === 1 && !d.geplanteRechnung);
      const antworten = await Promise.all(rechnungen.map(async (d) => {
        try {
          return { id: d.id, response: await $.ajax({
            url: `${process.env.VUE_APP_API_HOST}/400/410/`, type: 'post', dataType: 'json', timeout: 20000,
            data: { code: this.$store.state.login.session.code,
              dataToSave: JSON.stringify({ type: 'getEvidence', targetType: 'order_document', targetId: Number(d.id) }) },
          }) };
        } catch { return { id: d.id, response: null }; }
      }));
      antworten.forEach(({ id, response }) => {
        // Ein Read kann bereits fremde Aenderungen enthalten. Nur die eigene
        // Schreibantwort bestaetigt eine neue Zahlungsrevision fuer den Dialog.
        if (response && response.status === 'success') {
          this.nachweisGeaendert(id, { ...response, settlement: null });
        }
        else if (response && response.status === 'accessError') this.$store.commit('login/backendErrorSession');
      });
      this.nachweisAktualisierung += 1;
    },
    verknuepfteKostenName(kosten) {
      let res = `${String((kosten.betrag / (1 + (kosten.mwst / 100))).toFixed(2)).split('.').join(',')} €`;
      res += `: ${kosten.titel2}`;
      return res;
    },
    changeDokumentDatum(dokument) {
      const d = dokument.dateUpload2.split('-');
      dokument.dateUpload = `${d[2]}.${d[1]}.${d[0]}`;
      dokument.upload = `${dokument.dateUpload2} ${dokument.timeUpload}`;
      const time = Date.parse(`${dokument.dateUpload2}T${dokument.timeUpload}:00`);
      if (!Number.isNaN(time)) {
        dokument.time = Math.floor(time / 1000);
      }
      this.dokumentePage = 1;
    },
    changeLeistungKosten(leistung) {
      if (leistung.tabs_neuKosten === 0) {
        if (this.prop_kosten.filter((k) => k.id === leistung.id_kosten).length > 0) {
          const neuKosten = this.prop_kosten.filter((k) => k.id === leistung.id_kosten)[0];
          leistung.kosten = neuKosten.betrag/* / (1 + (neuKosten.mwst / 100)) */;
        } else {
          leistung.kosten = 0.00;
        }
      } else {
        leistung.kosten = leistung.neuKosten.betrag/* / (1 + (leistung.neuKosten.mwst / 100)) */;
      }
    },
    dokumentTimestamp(dokument) {
      const time = Number(dokument.time);
      if (Number.isFinite(time) && time > 0) {
        return time;
      }
      const datum = dokument.dateUpload2 || '';
      const uhrzeit = dokument.timeUpload || '00:00';
      const fallback = Date.parse(`${datum}T${uhrzeit}:00`);
      return Number.isNaN(fallback) ? 0 : Math.floor(fallback / 1000);
    },
    formatierePlanungszeitpunkt(zeitpunkt) {
      const [datum, uhrzeit = ''] = String(zeitpunkt).split(' ');
      const teile = datum.split('-');
      if (teile.length !== 3) {
        return zeitpunkt;
      }
      return `${teile[2]}.${teile[1]}.${teile[0]} ${uhrzeit}${uhrzeit ? ' Uhr' : ''}`;
    },
    geplantesDokumentArt(dokument) {
      const dokumentarten = this.prop_settings.auftraegeDokumentarten || [];
      const art = dokumentarten.find(
        (o) => String(o.nummer) === String(dokument.dokumentart),
      );
      return art ? (art.kurz || art.name) : `Dokumentart ${dokument.dokumentart}`;
    },
    geplantesDokumentWiederholung(dokument) {
      const planung = dokument.neuDokument || {};
      if (String(planung.terminPlanenWiederholen) !== '1') {
        return 'Einmalig';
      }
      const intervalle = {
        0: 'monatlich',
        1: 'jährlich',
        2: 'quartalsweise',
        3: 'halbjährlich',
      };
      const intervall = intervalle[Number(this.editAuftrag.vertrag_zahlungJaehrlich)];
      return intervall ? `Zahlungsintervall (${intervall})` : 'Zahlungsintervall';
    },
    geplantesDokumentNummer(dokument) {
      const planung = dokument.neuDokument || {};
      if (planung.automatischeReAnNummer !== false) {
        return 'Automatisch';
      }
      return `Manuell (${planung.reAnNummer || 'nicht angegeben'})`;
    },
    geplantesDokumentTextbloecke(dokument) {
      const planung = dokument.neuDokument || {};
      const ids = Array.isArray(planung.textbloecke) ? planung.textbloecke : [];
      const textbloecke = this.prop_settings.rechnungenTextbloecke || [];
      if (ids.length === 0) {
        return 'Keine';
      }
      return ids.map((id) => {
        const textblock = textbloecke.find((o) => String(o.id) === String(id));
        if (textblock) {
          return textblock.kurz || textblock.name || `Textblock ${id}`;
        }
        return String(id) === '1' ? 'Individueller Textblock' : `Textblock ${id}`;
      }).join(', ');
    },
    geplantesDokumentAnzahlung(dokument) {
      const planung = dokument.neuDokument || {};
      return Number(planung.anzahlung || 0)
        .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    },
    geplantesDokumentUnterschrift(dokument) {
      const planung = dokument.neuDokument || {};
      const unterschriften = this.prop_settings.unterschriften || [];
      const unterschrift = unterschriften.find(
        (o) => String(o.nummer) === String(planung.angebotUnterschriftAuftragnehmer),
      );
      return unterschrift ? unterschrift.name : 'Keine';
    },
    geplantesDokumentAnschrift(dokument) {
      const planung = dokument.neuDokument || {};
      if (planung.useIndividuelleAnschrift) {
        return planung.individuelleAnschrift || 'Keine Anschrift hinterlegt';
      }
      const anschrift = planung.anschrift || {};
      const strasse = [anschrift.strasse, anschrift.hausnummer].filter(Boolean).join(' ');
      const ort = [anschrift.plz, anschrift.ort].filter(Boolean).join(' ');
      return [anschrift.firma, anschrift.suffix, strasse, ort]
        .filter(Boolean)
        .join('\n') || 'Keine Anschrift hinterlegt';
    },
    geplantesDokumentEmailVersand(dokument) {
      const planung = dokument.neuDokument || {};
      return planung.terminPlanenSenden ? 'Ja' : 'Nein';
    },
    geplantesDokumentEmpfaenger(dokument) {
      const planung = dokument.neuDokument || {};
      const ansprechpartner = planung.ansprechpartner || {};
      return [
        ansprechpartner.anrede,
        ansprechpartner.vorname,
        ansprechpartner.nachname,
      ].filter(Boolean).join(' ') || 'Keine Ansprechperson hinterlegt';
    },
    geplantesDokumentEmail(dokument) {
      const planung = dokument.neuDokument || {};
      const ansprechpartner = planung.ansprechpartner || {};
      return ansprechpartner.mail || 'Keine E-Mail-Adresse hinterlegt';
    },
    addDokumente(dokumente) {
      const neueDokumente = Array.isArray(dokumente) ? dokumente : [];
      neueDokumente.forEach((d) => {
        this.editAuftrag.dokumente.push(d);
        this.prop_auftrag.dokumente.push(d);
      });
      if (neueDokumente.length === 0) {
        this.neuDokumentFehler = 'Das hochgeladene Dokument wurde nicht gespeichert.';
        return;
      }
      this.dokumentePage = 1;
      this.dialog_neuDokument = false;
      this.aktualisiereNachweise();
    },
    changedVertragBeginn() {
      const now = new Date(this.editAuftrag.vertrag_beginn);
      const dd = String(now.getDate()).padStart(2, '0');
      const mm = String(now.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = now.getFullYear() + 1; // Plus 1 Jahr
      this.editAuftrag.vertrag_ende = `${yyyy}-${mm}-${dd}`;
      const then = new Date(`${yyyy}-${mm}-${dd}`);
      then.setDate(then.getDate() - 4 * 7); // - 4 Wochen Kündigungsfrist
      const dd2 = String(then.getDate()).padStart(2, '0');
      const mm2 = String(then.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy2 = then.getFullYear(); // Plus 1 Jahr
      this.editAuftrag.vertrag_endeKuendigungsfrist = `${dd2}.${mm2}.${yyyy2}`;
    },
    changedVertragEnde(datum) {
      let d;
      if (!datum) {
        d = this.editAuftrag.vertrag_ende;
      } else {
        d = datum;
      }
      const then = new Date(d);
      then.setDate(then.getDate() - 4 * 7); // - 4 Wochen Kündigungsfrist
      const dd2 = String(then.getDate()).padStart(2, '0');
      const mm2 = String(then.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy2 = then.getFullYear(); // Plus 1 Jahr
      this.editAuftrag.vertrag_endeKuendigungsfrist = `${dd2}.${mm2}.${yyyy2}`;
    },
    leistungChangeLeistungstyp(leistung) {
      const [typ] = this.prop_settings.leistungstypen
        .filter((o) => o.id === leistung.id_leistungstyp);
      leistung.mwst = typ.mwst;
    },
    bruttoInNetto(leistung) {
      /* const [typ] = this.prop_settings.leistungstypen
        .filter((o) => o.id === leistung.id_leistungstyp);
      leistung.wert = parseInt(leistung.wertBrutto, 10) / (1 + typ.mwst / 100); */
      let res = parseFloat(leistung.wertBrutto, 10) / (1 + parseFloat(leistung.mwst) / 100);
      res = res.toFixed(2);
      leistung.wert = res;
    },
    nettoInBrutto(leistung) {
      /* const [typ] = this.prop_settings.leistungstypen
        .filter((o) => o.id === leistung.id_leistungstyp);
      leistung.wertBrutto = parseInt(leistung.wert, 10) * (1 + typ.mwst / 100); */
      let res = parseFloat(leistung.wert, 10) * (1 + parseFloat(leistung.mwst) / 100);
      res = res.toFixed(2);
      leistung.wertBrutto = res;
    },
    delLeistung(idx) {
      this.editAuftrag.leistungen.splice(idx, 1);
      this.editAuftrag_extPan_leistungen = null;
    },
    addLeistung() {
      const heute = new Date();
      const dd = String(heute.getDate()).padStart(2, '0');
      const mm = String(heute.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = heute.getFullYear();
      this.editAuftrag.leistungen.push({
        id: 0,
        id_auftrag: this.editAuftrag.id,
        id_leistungstyp: this.prop_settings.leistungstypen[0].id,
        id_einnahmestelle: this.prop_settings.einnahmestellen[0].id,
        pos: this.editAuftrag.leistungen.length + 1,
        titel: '',
        beschreibung: '',
        anzahl: 1,
        wert: 0,
        wertBrutto: 0,
        dialog_selectKosten: false,
        kosten: 0,
        id_kosten: 0,
        tabs_neuKosten: 0,
        neuKosten: {
          datum: `${yyyy}-${mm}-${dd}`,
          mwst: '19',
          id_kostenstelle: this.prop_settings.kostenstellen[0].id,
          betrag: 0,
          titel: '',
          beschreibung: '',
        },
        mwst: this.prop_settings.leistungstypen[0].mwst,
      });
      this.editAuftrag_extPan_leistungen = this.editAuftrag.leistungen.length - 1;
    },
    neuDokumentChangeDatum() {
      const heute = new Date();
      const dd = String(heute.getDate()).padStart(2, '0');
      const mm = String(heute.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = heute.getFullYear();
      const heute0 = new Date(`${yyyy}-${mm}-${dd}`);
      const termin = new Date(this.neuDokument.datum);
      if (heute0.getTime() - termin.getTime() <= 0) {
        this.neuDokument.showTerminPlanen = true;
      } else {
        this.neuDokument.showTerminPlanen = false;
      }
    },
    neuDokumentChangeAnsprechpartner() {
      [this.neuDokument.ansprechpartner] = this.neuDokument.moeglicheAnsprechpartner
        .filter((o) => o.id === this.neuDokument.ansprechpartnerId);
    },
    neuDokumentChangeAnschrift() {
      [this.neuDokument.anschrift] = this.neuDokument.moeglicheAnschriften
        .filter((o) => o.id === this.neuDokument.anschriftId);
    },
    neuDokumentGetMoeglicheUhrzeiten() {
      const help = [
        '00:00', '01:00', '02:00', '03:00',
        '04:00', '05:00', '06:00', '07:00',
        '08:00', '09:00', '10:00', '11:00',
        '12:00', '13:00', '14:00', '15:00',
        '16:00', '17:00', '18:00', '19:00',
        '20:00', '21:00', '22:00', '23:00',
      ];
      const heute = new Date();
      const dd = String(heute.getDate()).padStart(2, '0');
      const mm = String(heute.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = heute.getFullYear();
      const heute0 = new Date(`${yyyy}-${mm}-${dd}`);
      const termin = new Date(this.neuDokument.datum);
      if (
        heute0.getTime() === termin.getTime()
        && this.neuDokument.terminPlanenWiederholen !== '1'
      ) {
        const help2 = JSON.parse(JSON.stringify(help));
        help2.forEach((u) => {
          if (u <= `${String(heute.getHours() + 1).padStart(2, '0')}:00`) {
            help.splice(help.indexOf(u), 1);
          }
        });
        if (help.length <= 0) {
          this.neuDokument.showTerminPlanen = false;
          this.neuDokument.terminPlanen = false;
        } else {
          [this.neuDokument.terminPlanenUhrzeit] = help;
        }
      } else {
        this.neuDokument.terminPlanenUhrzeit = '06:00';
      }
      this.neuDokument.terminPlanenMoeglicheUhrzeiten = help;
    },
    neuDokumentKorrekturPruefen() {
      if (
        Number(this.neuDokument.dokumentart) !== 1
        || this.neuDokument.automatischeReAnNummer
        || this.neuDokument.terminPlanen
      ) {
        this.neuDokument.rechnungskorrekturBestaetigt = false;
      }
    },
    neuDokumentKorrekturBestaetigungGeaendert(aktiviert) {
      if (
        aktiviert === true
        && this.neuDokumentFehlerCode === 'invoice_number_already_assigned'
      ) {
        this.neuDokumentFehler = '';
        this.neuDokumentFehlerCode = '';
      }
    },
    updateNeuDokument() {
      if (
        this.prop_settings.auftraegeDokumentarten
          .filter((o) => o.nummer === this.neuDokument.dokumentart).length > 0
      ) {
        [this.neuDokument.dokumentartName] = this.prop_settings.auftraegeDokumentarten
          .filter((o) => o.nummer === this.neuDokument.dokumentart)[0].kurz
          .split(' ');
      } else {
        this.neuDokument.dokumentartName = '';
      }
      this.neuDokumentKorrekturPruefen();
      // this.neuDokument
      //  .terminPlanenSendenBetreff = `${this.neuDokument.dokumentartName} [[DOKUMENTNAME]]`;
      this.neuDokumentChangeDatum();
    },
    resetNeuDokument() {
      this.neuDokument = {
        automatischeReAnNummer: true,
        reAnNummer: 0,
        kundennummer: 0,
        id_auftrag: 0,
        dokumentart: 0,
        dokumentartName: '',
        datum: '',
        showTerminPlanen: false,
        terminPlanen: false,
        terminPlanenMoeglicheUhrzeiten: [],
        terminPlanenUhrzeit: '06:00',
        terminPlanenSenden: false,
        terminPlanenSendenMail: '',
        terminPlanenSendenText: '',
        terminPlanenSendenBetreff: '',
        terminPlanenWiederholen: '0',
        ansprechpartnerId: 0,
        ansprechpartner: {},
        moeglicheAnsprechpartner: [],
        anschriftId: 0,
        anschrift: {},
        moeglicheAnschriften: [],
        leistungen: [],
        useIndividuelleAnschrift: false,
        individuelleAnschrift: '',
        textbloecke: [],
        individuellerTextblock: '',
        anzahlung: 0,
        uploadTitel: '',
        angebotUnterschriftAuftragnehmer: '0',
        rechnungskorrekturBestaetigt: false,
      };
      // this.neuDokumentGetMoeglicheUhrzeiten();
      this.neuDokument.dokumentart = this.prop_settings.auftraegeDokumentarten[0].id;
      if (
        this.prop_kunden
          .filter((o) => o.kundennummer === this.editAuftrag.kundennummer).length > 0
      ) {
        this.neuDokument.moeglicheAnsprechpartner = this.prop_kunden
          .filter((o) => o.kundennummer === this.editAuftrag.kundennummer)[0].ansprechpartner;
        if (this.neuDokument.moeglicheAnsprechpartner.length > 0) {
          [this.neuDokument.ansprechpartner] = this.neuDokument.moeglicheAnsprechpartner;
          this.neuDokument.ansprechpartnerId = this.neuDokument.ansprechpartner.id;
        } else {
          this.neuDokument.ansprechpartner = {};
          this.neuDokument.ansprechpartnerId = 0;
          this.neuDokument.useIndividuelleAnschrift = true;
        }
        this.neuDokument.moeglicheAnschriften = this.prop_kunden
          .filter((o) => o.kundennummer === this.editAuftrag.kundennummer)[0].anschriften;
        if (this.neuDokument.moeglicheAnschriften.length > 0) {
          [this.neuDokument.anschrift] = this.neuDokument.moeglicheAnschriften;
          this.neuDokument.anschriftId = this.neuDokument.anschrift.id;
        } else {
          this.neuDokument.anschrift = {};
          this.neuDokument.anschriftId = 0;
          this.neuDokument.useIndividuelleAnschrift = true;
        }
      }
      const heute = new Date();
      const dd = String(heute.getDate()).padStart(2, '0');
      const mm = String(heute.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = heute.getFullYear();
      this.neuDokument.datum = `${yyyy}-${mm}-${dd}`;
      this.neuDokument.id_auftrag = this.editAuftrag.id;
      this.neuDokument.kundennummer = this.editAuftrag.kundennummer;
      this.neuDokument.leistungen = JSON.parse(JSON.stringify(this.editAuftrag.leistungen));
      this.neuDokument.auftragsdaten = JSON.parse(JSON.stringify(this.editAuftrag));
      this.neuDokumentGetMoeglicheUhrzeiten();
    },
    async trySaveNeuDokument() {
      // console.log(this.neuDokument);
      this.neuDokumentFehler = '';
      this.neuDokumentFehlerCode = '';
      this.$store.commit('main/switchIsSaving', true);
      this.loading_saveDokument = true;
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/400/410/neuDokument/`,
        type: 'post',
        data: {
          code: this.$store.state.login.session.code,
          dokument: JSON.stringify(this.neuDokument),
        },
        dataType: 'json',
        success: (response) => {
          if (response && response.status === 'accessError') {
            this.$store.commit('login/backendErrorSession');
            return;
          }
          if (!response || response.status === 'error' || !response.neuDokument) {
            this.neuDokumentFehlerCode = response && typeof response.code === 'string'
              ? response.code : '';
            this.neuDokumentFehler = sichereApiFehlermeldung(
              response && response.message,
              'Das Dokument konnte nicht erstellt werden. Bitte die Angaben prüfen.',
            );
            return;
          }
          const dokumentname = typeof response.neuDokument.name === 'string'
            ? response.neuDokument.name : '';
          if (!dokumentname) {
            this.neuDokumentFehler = 'Das erstellte Dokument konnte nicht eindeutig zugeordnet werden.';
            return;
          }
          const ersetzteDokumentIds = Array.isArray(
            response.neuDokument.replacedDocumentIds,
          ) ? response.neuDokument.replacedDocumentIds.map((id) => String(id)) : [];
          [this.editAuftrag.dokumente, this.prop_auftrag.dokumente].forEach((dokumente) => {
            for (let i = dokumente.length - 1; i >= 0; i -= 1) {
              if (ersetzteDokumentIds.includes(String(dokumente[i].id))) {
                dokumente.splice(i, 1);
              }
            }
          });
          this.editAuftrag.dokumente.push(response.neuDokument);
          this.prop_auftrag.dokumente.push(response.neuDokument);
          this.dokumentSpeicherungBestaetigt(response);
          this.dokumentePage = 1;
          this.dialog_neuDokument = false;
          this.aktualisiereNachweise();
        },
        timeout: 10000,
        error: (xhr, textStatus) => {
          if (
            xhr.responseJSON
            && xhr.responseJSON.status === 'accessError'
          ) {
            this.$store.commit('login/backendErrorSession');
            return;
          }
          this.neuDokumentFehlerCode = xhr.responseJSON
            && typeof xhr.responseJSON.code === 'string'
            ? xhr.responseJSON.code : '';
          this.neuDokumentFehler = apiFehlermeldung(
            xhr,
            textStatus,
            'Das Dokument konnte nicht erstellt werden. Bitte erneut versuchen.',
          );
        },
        complete: () => {
          this.$store.commit('main/switchIsSaving', false);
          this.loading_saveDokument = false;
        },
      });
    },
    async tryDelDokument(id, pfad) {
      this.$store.commit('main/switchIsSaving', true);
      if (this.editAuftrag.dokumente.filter((o) => o.id === id).length > 0) {
        this.editAuftrag.dokumente.filter((o) => o.id === id)[0].loadingDelete = true;
      }
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/400/410/`,
        type: 'post',
        data: {
          code: this.$store.state.login.session.code,
          dataToSave: JSON.stringify({ type: 'auftragDelDokument', id, pfad }),
        },
        success: (response) => {
          if (response.status === 'accessError') {
            this.$store.commit('login/backendErrorSession');
          } else if (
            response.status === 'success'
            && this.editAuftrag.dokumente.filter((o) => o.id === id).length > 0
          ) {
            this.editAuftrag.dokumente.splice(
              this.editAuftrag.dokumente.indexOf(
                this.editAuftrag.dokumente.filter((o) => o.id === id)[0],
              ),
              1,
            );
            this.prop_auftrag.dokumente.splice(
              this.prop_auftrag.dokumente.indexOf(
                this.prop_auftrag.dokumente.filter((o) => o.id === id)[0],
              ),
              1,
            );
            this.aktualisiereNachweise();
            if (response.settlement) this.nachweisGeaendert(null, response);
          } else if (response.status !== 'success') {
            this.$store.commit('main/alert', {
              typ: 'error',
              text: response.message || 'Das Dokument konnte nicht gelöscht werden.',
            }, { root: true });
          }
        },
        timeout: 10000,
        error: () => {
          // Einstellungen konnten nicht geladen werden
          this.$store.commit('main/alert', {
            typ: 'error',
            text: `Die Einstellungen konnten nicht gespeichert werden.
            Bitte die Netzwerkverbindung prüfen.`,
          }, { root: true });
        },
        complete: () => {
          this.$store.commit('main/switchIsSaving', false);
          if (this.editAuftrag.dokumente.filter((o) => o.id === id).length > 0) {
            this.editAuftrag.dokumente.filter((o) => o.id === id)[0].loadingDelete = false;
          }
        },
      });
    },
    async tryDownloadDokument(path, name, newTab) {
      this.$store.commit('main/switchIsSaving', true);
      if (this.editAuftrag.dokumente.filter((o) => o.pfad === path).length > 0) {
        this.editAuftrag.dokumente.filter((o) => o.pfad === path)[0].loadingDownload = true;
      }
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/data/download.php`,
        method: 'POST',
        data: {
          code: this.$store.state.login.session.code,
          file: path,
        },
        xhrFields: {
          responseType: 'blob',
        },
        success: (data) => {
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(data);
          a.href = url;
          if (newTab) {
            a.target = '_blank';
          } else {
            a.download = name;
          }
          document.body.append(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        },
        error: () => {
          this.$store.commit('main/alert', {
            typ: 'error',
            text: 'Die angeforderte Datei konnte nicht heruntergeladen werden. Bitte die Netzwerkverbindung prüfen.',
          }, { root: true });
        },
        complete: () => {
          this.$store.commit('main/switchIsSaving', false);
          if (this.editAuftrag.dokumente.filter((o) => o.pfad === path).length > 0) {
            this.editAuftrag.dokumente.filter((o) => o.pfad === path)[0].loadingDownload = false;
          }
        },
      });
    },
  },
  created() {
    this.editAuftrag = JSON.parse(JSON.stringify(this.prop_auftrag));
    this.xLoaded = JSON.stringify(this.prop_auftrag);
    this.dialog_editAuftrag = true;
    // this.changedVertragBeginn();
    this.changedVertragEnde();
    // this.resetNeuDokument();
  },
};
</script>
